import Inscription from './Inscription'
export default Inscription
